import React from 'react';
import { Body } from '@routific/hive';
import styled from 'styled-components';
import { StyledSkeleton } from './styles';

interface Props {
  displayName: string;
  isCompleted: boolean;
  loading: boolean;
}

const StyledBody = styled(Body)`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
`;

const VisitName: React.FC<Props> = ({ displayName, isCompleted, loading }) => {
  if (loading) {
    return (
      <span data-testid="order-status-skeleton">
        <StyledSkeleton active paragraph={false} title={{ width: 100 }} />
      </span>
    );
  }

  return <StyledBody type={isCompleted ? 'secondary' : undefined}>{displayName}</StyledBody>;
};

export default VisitName;
